import { defineStore } from 'pinia';

export const useRouterHistory = defineStore('routerHistory', {
  state: () => ({
    history: null as null | { to: string; from: string }
  }),
  actions: {
    saveHistory(to: string, from: string) {
      this.history = { to, from };
    }
  }
});
